module.exports = __webpack_public_path__ + "static/media/Suelo.2119b681.jpg";